// extracted by mini-css-extract-plugin
export default {"serverIsDownPage":"src-modules-bootstrap-style__serverIsDownPage_U2Fsd"};